module.exports = __webpack_public_path__ + "static/img/A6232.7ee66a35.png";